import styled from "styled-components";

export const DivTextRight = styled.div`
  text-align: right;
`;
